import { createSlice } from "@reduxjs/toolkit";

const contactSlice = createSlice({
    name: "contactSlice",
    initialState: {
        loading: false,
    },
    reducers: {
        contactRequest(state, action) {
            return {
                ...state,
                loading: true,
            };
        },
        contactSuccess(state, action) {
            return {
                loading: false,
                allContact: action.payload.allContact,
            };
        },
        contactFail(state, action) {
            return {
                loading: false,
                error: action.payload,
            };
        },
        contactDeleteRequest(state, action) {
            return {
                ...state,
                loading: true,
            };
        },
        contactDeleteSuccess(state, action) {
            return {
                loading: false,
            };
        },
        contactDeleteFail(state, action) {
            return {
                loading: false,
                error: action.payload,
            };
        },
    },
});

const { actions, reducer } = contactSlice;

export const {
    contactRequest,
    contactSuccess,
    contactFail,
    contactDeleteRequest,
    contactDeleteSuccess,
    contactDeleteFail,
} = actions;

export default reducer;
